import { useState } from 'react'
import type { FC } from 'react'
import { Box, Button, IconButton, TextField } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlineOutlined'

interface StickyNoteEditDialogProps {
  handleStickyNoteSave: (note: string) => void
  previousNote?: string
}

/**
 * Provider sticky-note editor used by the member header; saving/clearing
 * persists through the caller.
 */
export const StickyNoteEditDialog: FC<StickyNoteEditDialogProps> = props => {
  const { handleStickyNoteSave, previousNote } = props

  const [text, setText] = useState(previousNote ? previousNote : '')

  const characterLimit = 150

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
      <br />
      <TextField
        id="standard-basic"
        sx={{ width: '30rem' }}
        label={`Add/Update Note: ${text.length}/${characterLimit}`}
        variant="standard"
        onChange={event => setText(event.target.value)}
        defaultValue={previousNote}
        multiline
        slotProps={{ htmlInput: { maxLength: characterLimit } }}
      />
      <Box>
        <IconButton
          color="inherit"
          onClick={() => {
            handleStickyNoteSave('')
          }}
        >
          <DeleteOutlineIcon style={{ color: 'red' }} />
        </IconButton>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            handleStickyNoteSave(text)
          }}
          style={{ width: '30%' }}
        >
          Save
        </Button>
      </Box>
    </Box>
  )
}
